import { createAsyncThunk } from '@reduxjs/toolkit';

export const setDocumentIsLoaded = createAsyncThunk(
  'setDocumentIsLoaded',
  async (
    data: { documentIsLoaded: boolean },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      documentIsLoaded: data.documentIsLoaded,
    };
  }
);

export default setDocumentIsLoaded;
